<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import { Loader } from "lucide-svelte"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  interface Props {
    user: UserType
    oncancel: (user: UserType) => void
    onupdate: (user: UserType) => void
  }

  let { user = $bindable(), oncancel, onupdate }: Props = $props()
  const form = { ...user, saving: false }

  async function updateMember() {
    const {
      name,
      display_name,
      title,
      mobile_number,
      birthdate,
      work_anniversary
    } = form
    form.saving = true
    try {
      const resp = await xhr.patch(
        `/plans/${appStore.plan.id}/admin/members/1`,
        {
          member: {
            user_id: user.id,
            name,
            display_name,
            title,
            mobile_number,
            birthdate,
            work_anniversary
          }
        }
      )

      toast("The member has been updated.", "success")
      console.log(resp.data)
      onupdate(resp.data)
    } catch (e) {
      Honeybadger.notify(e)
      toast("There was an error updating the member", "error")
    } finally {
      form.saving = false
    }
  }

  let promise = $state(Promise.resolve())
  function handleUpdate() {
    promise = updateMember()
  }
</script>

<div class="grid grid-cols-12 px-4 gap-4">
  <div class="whitespace-nowrap col-span-4">
    <label for="" class="text-xs text-gray-500">Full Name</label>
    <div class="text-gray-900">
      <input type="text" bind:value={form.name} class="input flex-auto" />
    </div>
  </div>

  <div class="whitespace-nowrap col-span-4">
    <label for="" class="text-xs text-gray-500">Display Name</label>
    <div class="text-sm text-gray-900">
      <input
        type="text"
        bind:value={form.display_name}
        class="input flex-auto w-full lg:w-56"
      />
    </div>
  </div>

  <div class="whitespace-nowrap col-span-4">
    <label for="" class="text-xs text-gray-500">Role</label>
    <div
      class="text-sm text-gray-900 bg-gray-50 border border-gray-200 rounded-md py-2 px-2 mt-1 italic"
    >
      {appStore.user_roles[user.role]}
    </div>
  </div>
</div>

<div class="px-8 pt-4">
  <hr />
</div>
<!--Second row-->
<div class="grid grid-cols-12 px-4 gap-4">
  <div class="whitespace-nowrap col-span-3">
    <label for="" class="text-xs text-gray-500">Title</label>
    <div class="text-gray-900">
      <input type="text" bind:value={form.title} class="input flex-auto" />
    </div>
  </div>

  <div class="whitespace-nowrap col-span-3">
    <label for="" class="text-xs text-gray-500">Mobile Number</label>
    <div class="text-sm text-gray-900">
      <input
        type="text"
        bind:value={form.mobile_number}
        class="input flex-auto"
      />
    </div>
  </div>

  <div class="whitespace-nowrap col-span-3">
    <label for="" class="text-xs text-gray-500">Birthday</label>
    <div class="text-sm text-gray-900">
      <input type="date" bind:value={form.birthdate} class="input flex-auto" />
    </div>
  </div>

  <div class="whitespace-nowrap col-span-3">
    <label for="" class="text-xs text-gray-500">Work Aniversary</label>
    <div class="text-sm text-gray-900">
      <input
        type="date"
        bind:value={form.work_anniversary}
        class="input flex-auto"
      />
    </div>
  </div>
</div>

<!--Buttons-->
<div class="text-center py-4">
  <button
    class="btn primary mr-2"
    title="Update"
    disabled={form.saving}
    onclick={() => handleUpdate()}
  >
    {#await promise}
      <Loader class="rotate" />
    {:then}
      Update
    {:catch error}
      Update
    {/await}
  </button>
  <button
    class="btn secondary"
    title="Cancel"
    onclick={() => {
      oncancel(user)
    }}
  >
    Cancel
  </button>
</div>
